// extracted by mini-css-extract-plugin
export default {"ctn":"bigVideoLayout_ctn__YRnNg"};